// extracted by mini-css-extract-plugin
export default {"container":"ExtWindowTrim_container__UKVuj","productListContainer":"ExtWindowTrim_productListContainer__G09kd","productGrid":"ExtWindowTrim_productGrid__WhaQM"};